import { compact } from 'lodash';

import { InspectionModel } from '@main-application/inspections/models/inspection.model';
import { RestPropertyModel } from '@shared/interfaces/rest-portfolio-model.interface';
import { RestUserModel } from '@shared/interfaces/user.interface';
import { RestTemplateModel } from '@template/models/rest-template-model.interface';

import { RestInspectionsModel } from './rest-inspections-model.interface';

export class InspectionListItemModel extends InspectionModel {
  readonly notifyWhenDone: RestUserModel[];
  readonly progress: number;
  readonly createUser: RestUserModel;
  readonly propertyNameWithUnits: string;

  constructor(
    entityDetails: RestInspectionsModel,
    inspectionTemplate: RestTemplateModel,
    properties: RestPropertyModel[],
    users: Map<number, RestUserModel>
  ) {
    super(entityDetails, inspectionTemplate, [], users);
    if (this.propertyId && !this.propertyName) {
      this.propertyName = properties.find(x => x.id === this.propertyId)?.name;
    }

    const notifyWhenDoneIds = entityDetails.notifyWhenDoneUserIds?.split(',') || [];
    this.notifyWhenDone = compact(notifyWhenDoneIds.map(id => users.get(Number(id))));

    const сompleted = entityDetails.completedChildInspections || 0;
    const all = сompleted + entityDetails.uncompletedChildInspections || 0;
    this.progress = all > 0 ? (сompleted * 100) / all : 0;

    this.createUser = users.get(entityDetails.createdBy);

    const units = entityDetails.bulkUnitIds?.length ? entityDetails.bulkUnitIds.length + ' units' : 'All units';
    this.propertyNameWithUnits = `${this.propertyName} - ${units}`;
  }
}
